function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './RestaurantsNavigation.css';
import React, { memo, useState } from 'react';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { ReactComponent as IconChevronDown } from "../../resources/icons/IconChevronDown.svg";
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import { canUseDOM, get, getDictionaryItem } from '../../utils';
import Select from 'react-select';
import { BASE_SINGLE_SELECT_PROPS } from '../../utils/constants';
import { isNil, isNotNil } from '../../utils/IsNil';
import getListing from '../../utils/getListing';
import { convertToAnalyticObject } from '../../utils/analytics';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
import RouterLink from '../atoms/RouterLink';
import { replacerPlusAndAmpersandForValidQueryString } from '../../utils/replacerPlusAndAmpersandForValidQueryString';
const reactSelectSingleUiSettings = _objectSpread(_objectSpread({}, BASE_SINGLE_SELECT_PROPS), {}, {
  styles: _objectSpread(_objectSpread({}, BASE_SINGLE_SELECT_PROPS.styles), {}, {
    option: (base, state) => _objectSpread(_objectSpread({}, base), {}, {
      ".contrast &, .dark &": {
        ":hover": {
          backgroundColor: "#8080806e"
        },
        ":active": {
          backgroundColor: "#8080806e"
        },
        backgroundColor: state.isFocused ? "#8080806e" : state.isSelected ? "#808080" : base.backgroundColor,
        color: state.isSelected ? "#4D4D4D" : "black"
      }
    })
  })
});
const RestaurantsNavigation = /*#__PURE__*/memo(_ref => {
  let {
    params,
    fields
  } = _ref;
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const algoliaSettings = {
    key: get(sitecoreContext, 'configuration.algolia.algoliaApiKey'),
    id: get(sitecoreContext, 'configuration.algolia.algoliaApplicationId'),
    fullTextSearchIndex: get(sitecoreContext, 'configuration.algolia.fullTextSearchIndex')
  };
  const pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  const [isVdsite, setIsVdsite] = React.useState(true);
  const [selectedOptions, setSelectedOptions] = React.useState(null);
  const [options, setOptions] = React.useState([]);
  const [cuisinesList, setCuisinesList] = useState([]);
  const types = "type:Restaurant";
  const algoliaIndexes = get(params, 'SearchIndex');
  const title = get(fields, "data.datasource.title.jss.value");
  const subTitle = get(fields, "data.datasource.text.jss.value");
  const facetName = get(fields, "data.datasource.fieldName.targetItem.fieldName.jss.value");
  const href = get(fields, "data.datasource.overviewLink.jss.value.href");
  const linktype = get(fields, "data.datasource.overviewLink.jss.value.linktype");
  const moduleDictionary = get(fields, 'data.moduleDictionary');
  const ctaButtonText = getDictionaryItem(moduleDictionary, 'ShowRestaurants');
  const selectNeighbourhoodPlaceholder = getDictionaryItem(moduleDictionary, 'SelectNeighbourhood');
  let eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  const linkAnalyticsClick = textArray => {
    tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['linkClickAnalytics'], params), textArray);
  };
  const createNeighbourhoodNavigation = hits => {
    const navigationObj = {};
    hits.forEach(hit => hit.location.forEach(currentLocation => {
      isNotNil(navigationObj[currentLocation]) ? navigationObj[currentLocation]++ : navigationObj[currentLocation] = 1;
    }));
    const navigationArray = Object.entries(navigationObj).map(_ref2 => {
      let [name, count] = _ref2;
      return {
        name,
        count
      };
    });
    const options = Object.entries(navigationObj).map(_ref3 => {
      let [name] = _ref3;
      return {
        label: name,
        value: name
      };
    });
    setCuisinesList(navigationArray);
    setOptions(options);
  };
  const algoliaRequest = () => {
    const itemFilters = {
      facetFilters: [types]
    };
    getListing(algoliaIndexes, itemFilters, algoliaSettings).then(response => {
      createNeighbourhoodNavigation(response.hits);
    }).catch(error => {
      console.log("error", error);
    });
  };
  React.useEffect(() => {
    algoliaRequest();
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  if (isNil(fields) || isNil(fields.data) || isNil(fields.data.datasource) || isNil(facetName)) {
    console.info('RestaurantsNavigation component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, " [RestaurantsNavigation component is empty: please provide data source]");
    }
    return null;
  }
  const goToUrl = () => {
    window.location.href = `${href}?${facetName}=${replacerPlusAndAmpersandForValidQueryString(selectedOptions.value)}`;
  };
  const isRestaurantsNavigationButtonEnabled = () => selectedOptions !== null;
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("h3", {
    className: "title"
  }, title), /*#__PURE__*/React.createElement("p", {
    className: "subTitle"
  }, subTitle), /*#__PURE__*/React.createElement("div", {
    className: "restaurantsNavigationGridContainer"
  }, cuisinesList.map((el, index) => /*#__PURE__*/React.createElement(RouterLink, {
    href: `${href}?${facetName}=${replacerPlusAndAmpersandForValidQueryString(el.name)}`,
    linktype: linktype,
    className: "restaurantsNavigationItem",
    onClick: () => linkAnalyticsClick([title, el.name]),
    key: index
  }, /*#__PURE__*/React.createElement(IconChevronDown, {
    className: "icon"
  }), /*#__PURE__*/React.createElement("span", null, el.name), /*#__PURE__*/React.createElement("span", {
    className: "restaurantsNavigationCount"
  }, "(", el.count, ")")))), /*#__PURE__*/React.createElement("div", {
    className: "restaurantsNavigationMobileView"
  }, /*#__PURE__*/React.createElement(Select, _extends({}, reactSelectSingleUiSettings, {
    options: options,
    className: `react-custom-select`,
    onChange: el => setSelectedOptions(el),
    placeholder: selectNeighbourhoodPlaceholder,
    value: selectedOptions
  })), /*#__PURE__*/React.createElement("button", {
    onClick: goToUrl,
    className: `btn btn-primary ${isRestaurantsNavigationButtonEnabled() ? "" : "disabled"}`,
    disabled: !isRestaurantsNavigationButtonEnabled()
  }, ctaButtonText)));
});
const StyledWrapper = _ref4 => {
  let {
    children,
    rtl
  } = _ref4;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    className: `${commonStyles} ${rtl ? rtlStyles : ltrStyles}`
  }, children);
};
const commonStyles = "c8mfi4";
const ltrStyles = "l1s4rdjc";
const rtlStyles = "rqon255";
export default RestaurantsNavigation;